module.exports = __webpack_public_path__ + "img/know-more.4556245.webp";